import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Dispatch, SetStateAction } from 'react';
import { Divider } from '@mui/material';


export default function ConfirmDialog(
    { open, setOpen, callback }:
        {
            open: boolean,
            setOpen: Dispatch<SetStateAction<boolean>>,
            callback: () => void
        }) {

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={{
                '& .MuiPaper-root': {
                    background: 'var(--color-white) !important'
                },
            }}>
            <DialogTitle style={{ color: 'var(--color-black)' }} fontWeight={600} fontSize={'1.1rem'} id="alert-dialog-title"> {"Você tem Certeza?"}</DialogTitle>
            <Divider variant='fullWidth' style={{ background: 'grey' }}/>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Se você realizar esta operação seus documentos salvos previamente serão deletados.
                </DialogContentText>
            </DialogContent>
            <Divider variant='fullWidth' style={{ background: 'grey' }}/>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={() => {
                    setOpen(false)
                    callback()
                }} autoFocus>Confirmar</Button>
            </DialogActions>
        </Dialog>
    )
}